import { Controller } from "@hotwired/stimulus"

// Me's photo row (persona/show): picking a file previews it in the thumb and
// only then shows the paid "Paint me" button, so choosing a photo never spends
// credits by itself.
export default class extends Controller {
  static targets = ["input", "thumb", "choose", "submit", "hint"]

  disconnect() {
    if (this._url) URL.revokeObjectURL(this._url)
  }

  picked(event) {
    // The row sits inside the persona editor; a photo is not an unsaved
    // change to that form (it has its own).
    event.stopPropagation()
    const file = this.inputTarget.files && this.inputTarget.files[0]
    if (!file) return
    if (this._url) URL.revokeObjectURL(this._url)
    this._url = URL.createObjectURL(file)
    const img = document.createElement("img")
    img.src = this._url
    img.alt = "Your new photo"
    this.thumbTarget.replaceChildren(img)
    this.chooseTarget.textContent = "Pick another"
    this.hintTarget.textContent = "Looks right? Paint your portrait from it."
    this.submitTarget.hidden = false
  }
}
